export default __webpack_public_path__ + "static/media/undereyePuffinessActive.59590f6b.svg";